import { useQuery } from '@tanstack/react-query';

import { getClaimCampaign } from '~/services/LuxLoyalty';

import { claimCampaignQueryKeys } from './claimCampaignQueryKeys';

interface UseGetClaimCampaignOptions {
  enabled?: boolean;
}

/**
 * Fetches a single claim campaign by ID.
 */
export function useGetClaimCampaign(campaignId: string, options: UseGetClaimCampaignOptions = {}) {
  const { enabled = true } = options;

  return useQuery({
    queryKey: claimCampaignQueryKeys.detail(campaignId),
    queryFn: async () => {
      return await getClaimCampaign(campaignId);
    },
    enabled: enabled && !!campaignId,
    retry: false,
  });
}
